import { useState, useEffect } from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";



interface InventoryAlertProps {
	checkoutState: any;
	productData: any;
    updateToInventoryQuantity: any;
    setUpdateToInventoryQuantity: any;
}

const InventoryAlert: React.FC<InventoryAlertProps> = ({ checkoutState, productData, updateToInventoryQuantity,  setUpdateToInventoryQuantity }) => {
  // Filter items where cart quantity is more than availabilityCount
  const unavailableItems = checkoutState?.lineItems?.filter((lineItem: any) => {
    const product = productData?.find(
      (p: any) => p.productId === lineItem.variant.sku
    );
    return product && lineItem.quantity <=0;
  });


  useEffect(()=>{
    const unavailableItemsConsideringMoreQuantity = checkoutState?.lineItems?.filter((lineItem: any) => {
        const product = productData?.find(
          (p: any) => p.productId === lineItem.variant.sku
        );
        return product && lineItem.quantity > product.availabilityCount;
      });

      if(unavailableItemsConsideringMoreQuantity.length > 0){
        console.log("Fix cart kickedIn");
        setUpdateToInventoryQuantity(true);
      }
  },[productData])

  if(!updateToInventoryQuantity){
    return (
        <>
          {unavailableItems.length > 0 && (
            <div
              style={{
                backgroundColor: "#f8d7da",
                border: "1px solid #f5c6cb",
                padding: "16px",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            >
              <Typography variant="h6" sx={{ color: "#721c24" }}>
                Inventory items are not available
              </Typography>
              {unavailableItems.map((lineItem: any, index: number) => (
                <a href={`#${lineItem.variant.sku}`} key={`#${'unavailableItem' + index}`}>
                <Card key={index} sx={{ marginTop: "8px", backgroundColor: "#fff" }}>
                  <CardContent>
                    <Typography variant="body1" fontWeight="bold" sx={{ fontSize: "13px" }}>
                      {lineItem.title}
                    </Typography>
                    <Typography variant="body2">
                      Ordered: {lineItem.quantity}, Available:{" "}
                      {productData.find((p: any) => p.productId === lineItem.variant.sku)
                        ?.availabilityCount || 0}
                    </Typography>
                  </CardContent>
                </Card></a>
              ))}
            </div>
          )}
        </>
      );
  }
  return null;
};

export default InventoryAlert;
